import React, {Component} from "react";
import "./Consumer.scss";
import ContentTemplate from "../ContentTemplate/ContentTemplate";
import FourPillars from "../../assets/images/four-pillars.png";
import Constants from "../Constants";
import {HashLink as Link} from "react-router-hash-link";
import CodeSnippetTemplate from "../CodeSnippetTemplate/CodeSnippetTemplate";
import CodeSnippet from "../../model/CodeSnippet";
import {CodeSnippetLanguages} from "../CodeSnippetTemplate/CodeSnippetLanguages";
import imgSorryConsumerSnapshot from "../../assets/images/sorry-consumer-snapshot.png";
import imgConsumerSnapshot from "../../assets/images/snapshot-consumer.png";
import imgDealershipInfoOnChbv from "../../assets/images/dealership-info-chbv.png"
import imgDealershipInfoOnReport from "../../assets/images/dealership-info-report.png"
import PartnerPortalApplications from "../../assets/images/partner-portal-applications.png";
import CarCareCheck from "../../assets/images/car-care-check.png";
import CarCareError from "../../assets/images/car-care-error.png";
import CarCareDisplayableErrorMessage from "../../assets/images/car-care-displayable-error-message.png";
import CarCareStyleImageOne from "../../assets/images/car-care-style-image-1.png";
import CarCareCheckMyCar from "../../assets/images/car-care-check-my-car.png";
import CarCareLicensePlateData from "../../assets/images/car-care-license-plate-data.png";
import CarCareVinData from "../../assets/images/car-care-vin-data.png";
import CarCareTakeMeToCarCare from "../../assets/images/car-care-take-me-to-car-care.png";
import CarCareRecallDetailsOne from "../../assets/images/car-care-recall-details-1.png";
import CarCareRecallDetailsTwo from "../../assets/images/car-care-recall-details-2.png";
import CarCareRecallDetailsThree from "../../assets/images/car-care-recall-details-3.png";
import CarCareCarfaxLogo from "../../assets/images/CARFAX Logo.svg";
import CarCareRecallAlert from "../../assets/images/Recall Alerts.svg";
import CarCareServiceDue from "../../assets/images/Services Due.svg";
import CarCareServiceOverdue from "../../assets/images/Services Overdue.svg";
import CarCareCarFox from "../../assets/images/Car Fox.svg";
import CarCareInfo from "../../assets/images/Info.svg"
import Button from "@carfax-stencils/button";
import JSZip from "jszip";
import ServiceLaneExperience from "./ServiceLaneExperience/ServiceLaneExperience";


export default class Consumer extends Component<any, any> {
    private consumerNavigationLinks: Map<string, string> = new Map([
        ["#instant-carfax-report", "Instant CARFAX Report"],
        ["#record-check", "Record Check"],
        ["#consumer-snapshot", "Consumer Snapshot"],
        ["#vehicle-information", "Vehicle Information"],
        ["#for-sale-by-owner", "For Sale By Owner"]
    ]);

    private carCareNavigationLinks: Map<string, string> = new Map([
        ["#car-care-overview", "Overview"],
        ["#car-care-prerequisites", "Prerequisites"],
        ["#car-care-authentication", "Authentication"],
        ["#car-care-request", "Sending a Request"],
        ["#car-care-errors", "Errors"],
        ["#car-care-style-guide", "Style Guide"]
    ]);
    private serviceLaneExperienceeNavigationLinks: Map<string, string> = new Map([
        ["#sle-overview", "Overview"],
        ["#sle-user-journey", "User Journey"],
        ["#sle-integration-diagram", "Integration Architecture Diagram"],
        ["#sle-map-service-shops", "Map Service Shops"],
        ["#sle-connect-setup", "SLE Link Generation"],
        ["#sle-dealer-eligibility", "Shop Eligibility Check"],
        ["#sle-rate-limits", "Rate Limits on CARFAX Connect"],
        ["#sle-testing", "Testing the Integration"]
    ]);

    private navLinksMap: Map<string, Map<string, string>> = new Map([
        ["Consumer", this.consumerNavigationLinks],
        ["Car Care Check", this.carCareNavigationLinks],
        ["Service Lane Experience", this.serviceLaneExperienceeNavigationLinks]
    ]);

    public render() {
        return (
            <div className={"consumer"}>
                <ContentTemplate
                    pageTitle="Consumer"
                    navlinksMap={this.navLinksMap}
                    content={this.getContentHtml()}
                />
            </div>
        );
    }

    private getContentHtml(): JSX.Element {
        return (
            <div className={"content-container"}>
                <h1 id="consumer-header">Consumer</h1>
                <section>
                    <h3 id="instant-carfax-report">Instant CARFAX Report</h3>
                    <p>
                        An Instant CARFAX Report (ICR) is a publicly available CARFAX Report paid for by a dealer or
                        Certified Preowned partner. ICRs become available when a partner reports to CARFAX that the
                        vehicle is for sale by a dealer that has an active subscription with CARFAX.
                        <br/>
                        There are three distinct configurations for querying ICRs depending on the nature of your site:
                    </p>
                    <p>
                        <ul>
                            <li>
                                <b>Dealer Matched - </b> Standard configuration for most partners who are hosting dealer
                                websites
                                or "automalls". The ICR is made available based on the dealer/VIN combination provided
                                in
                                a nightly dealer and inventory file sent to CARFAX representing all inventory on your
                                site.
                                CARFAX Connect is then used in lieu of a return file to fetch all available ICRs from
                                the
                                most recent pool of inventory sent in the file. Your account manager will provide
                                separate
                                instructions for supplying the daily files. Note that CARFAX Advantage dealers benefit
                                the
                                most from using this configuration as they are able to ensure an ICR is available for
                                all retail
                                cars listed on your site. In addition, CARFAX Advantage dealers with vehicles featured
                                on CARFAX
                                Used Car Listings may receive Value Badges on their ICRs and your site. All dealers
                                receive
                                attribution on the ICR showing the dealership name, address, phone number, etc. as seen
                                below.
                                For implementation details see
                                <a href={"#dealer-matched"}> Consumer Partner - Dealer Matched</a>.
                                <br/>
                                <img
                                    height={400}
                                    width={800}
                                    alt="Dealership info on CHBV including name, address, phone number, etc "
                                    src={imgDealershipInfoOnChbv}
                                />
                                <br/>
                                <img
                                    height={400}
                                    width={700}
                                    alt="Dealership info on CARFAX report including name, address, phone number, etc "
                                    src={imgDealershipInfoOnReport}
                                />
                            </li>
                            <br/>
                            <li>
                                <b>Inventory Aggregator -</b> An option for partners who aggregate inventory from
                                multiple partner
                                sources on one site. To present ICRs a dealer ID/VIN is sent via Connect but in this
                                case the
                                dealer ID is the same one used by the partner with CARFAX sending the inventory to the
                                aggregator.
                                No inbound inventory file is required in this case.
                                For implementation details see
                                <a href="#inventory-aggregator"> Consumer Partner - Inventory Aggregator
                                </a> below.

                            </li>
                            <br/>
                            <li>
                                <b>VIN Only -</b> This option is reserved for rare cases where a partner is unable to do
                                a dealer
                                match due to contractual or data reasons. ICRs may still be provided via Connect but
                                they do not
                                afford the benefits of Value Badging nor dealer attribution on the report.
                                No inbound inventory file is required in this case. For implementation details see
                                <a href="#vin-only"> Consumer Partner - VIN Only </a> below.

                            </li>
                        </ul>
                    </p>
                    <p>
                        Note that an ICR may not be initially available if the report has not been run by a dealer,
                        the dealer ID does not match or a dealer's account is not active or valid. While the CARFAX
                        Report has a lifespan of 90-150 days the <b>ICR URLs expire after seven days for security
                        purposes</b>. It is recommended that all VINs on your site be refreshed nightly to ensure the
                        badges are updated but if you are caching any data/links, be sure to refresh
                        it before
                        the <code>expiresAt</code> timestamp. ICRs may stop being available prior to the expiration time
                        if the
                        selling dealer asks us to remove it, the partner stops reporting that the vehicle is for sale,
                        or the
                        report for the partner expires. Note that an ICR may stop being available prior to the
                        expiration time if the
                        selling dealer asks us to remove it, the partner stops reporting that the vehicle is for sale,
                        or the
                        report for the partner expires. Should the ICR become unavailable but the link remain a user
                        opening
                        it will be redirected to a CARFAX Record Check where the report may be purchased.
                    </p>
                    <p>
                        If your agreement provides for the display of CARFAX Value Badge icons note that the iconUrl
                        field will
                        return one of the first six options as noted below. These SVG files are able to be resized.
                    </p>
                    <p>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/1own_great.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/1own_great.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/1own_good.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/1own_good.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/1own_fair.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/1own_fair.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/great.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/great.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/good.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/good.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/fair.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/fair.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/1own.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/1own.svg
                        </a>
                        <br/>
                        <a href="https://partnerstatic.carfax.com/img/valuebadge/showme.svg">
                            https://partnerstatic.carfax.com/img/valuebadge/showme.svg
                        </a>
                    </p>
                    <h5>ADA Compliance / Accessibility</h5>
                    <p>
                        CARFAX is committed to making our products accessible to everyone including people with
                        disabilities. We are continuously improving our sites and products to follow the Web Content
                        Accessibility Guidelines (WCAG). We recommend that our partners abide by the guidelines put
                        forward through WCAG. In doing so, we ask that all logos displayed on your sites and products
                        are properly coded to meet the standards of WCAG. The valueBadgeAltText value in the Connect
                        response provides the alternate text for all logos that can be displayed. Text should be coded
                        as ALT="CARFAX 1-Owner Great Value Logo" for example.
                    </p>
                </section>
                <hr/>
                <section>
                    <h5 id="dealer-matched">Consumer Partner &mdash; Dealer Matched</h5>
                    <p>
                        Use the icr field to obtain a link to the ICR. This field returns the IcrResult interface type.
                        If the ICR is available, the concrete type will be IcrAvailable, which includes the ICR link and
                        other data from the CARFAX Report as provisioned.
                        <br/>
                        To display the ICR link on a web page, use the image provided in the iconUrl field. The URL
                        returned may be one of the eight varieties noted above depending on whether you are provisioned
                        with CARFAX Value Badges. For example, qualifying vehicles display a one-owner badge when the
                        vehicle has exactly one prior owner. The image is an SVG, so you can scale it to fit your
                        layout.
                    </p>
                    <p>
                        Here is an example query that obtains the ICR URL only when the ICR is
                        available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query($icrInput: IcrInput!) {
    icr(icrInput: $icrInput) {
        ... on IcrAvailable {
            carfaxLink {
                url
                iconUrl
                valueBadgeAltText
                expiresAt {rfc}
            }
            ownerHistory {
                oneOwner
            }
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        This query uses an <a href="https://graphql.org/learn/queries/#inline-fragments"
                                              target="_blank"
                                              rel="noopener noreferrer">
                        Inline Fragment
                    </a> to ask for the <code>carfaxLink</code> only when the <code>icr</code>{" "}
                        field returns the <code>IcrAvailable</code> type. If the ICR is not
                        available, the type returned is <code>IcrNotAvailable</code>, and the
                        contents of the inline fragment block are ignored.
                    </p>
                    <p>
                        The example query uses the RFC 3339/ISO 8601 human readable
                        representation of the <code>expiresAt</code> timestamp. The{" "}
                        <code>Timestamp</code> type also offers UNIX time as seconds or
                        milliseconds, which is easier to parse in many programming languages.
                    </p>
                    <p>
                        Variables for the example query:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        icrInput: {
                                            vin: "3FMDK4JCXDBE32612",
                                            dealerId: "1504",
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        The <code>icr</code> field has one argument, of type <code>IcrInput</code>. You can see
                        the 2 properties of this type in the schema browser.
                    </p>
                </section>
                <hr/>
                <section>
                    <h5 id="inventory-aggregator">Consumer Partner &mdash; Inventory Aggregator</h5>
                    <p>
                        If you are a partner who aggregates inventory
                        from multiple partner sources then you will need to add an
                        "originatingPartner" parameter to <code>IcrInput</code>
                        that represents a unique ID provided by CARFAX for the given partner
                        source.
                    </p>
                    <p>
                        Below is an example of the <code>IcrInput</code> variable that obtains
                        the ICR URL only when the ICR is available as associated with the
                        given originatingPartner. Note that the dealerId is that used by the partner
                        with CARFAX which is listing inventory on the aggregator's site.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        icrInput: {
                                            vin: "ABCDEFGHWJKL50114",
                                            originatingPartner: "ABCD1234",
                                            dealerId: "1234QWER",
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h5 id="vin-only">Consumer Partner &mdash; VIN Only</h5>
                    <p>
                        If you are a partner who supports only the VIN to run an ICR, then
                        you need to provide only the VIN and none of the other parameters to get an ICR.
                    </p>
                    <p>
                        Below is an example of the <code>IcrInput</code> variable that obtains
                        the ICR URL only when the VIN is in inventory:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        icrInput: {
                                            vin: "ABCDEFGHWJKL50114",
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample result when ICR is available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            icr: {
                                                carfaxLink: {
                                                    url:
                                                        "https://www.carfax.com/VehicleHistory/ar20/K9rr0LBSzBZAF2",
                                                    iconUrl:
                                                        "https://partnerstatic.carfax.com/img/valuebadge/1own.svg",
                                                    valueBadgeAltText:
                                                        "CARFAX 1-Owner Logo",
                                                    expiresAt: {
                                                        rfc: "2020-02-07T20:38:35.906Z",
                                                    },
                                                },
                                                ownerHistory: {
                                                    oneOwner: true
                                                }
                                            },
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>

                    <p>
                        Sample response when ICR is not available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        "data": {
                                            "icr": {
                                                "carfaxLink": {
                                                    "url": "https://carfax.com/cfm/check_order.cfm?partner=XXX&vin=XXX",
                                                    "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/showme.svg"
                                                }
                                            }
                                        }
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>

                    <p>
                        Since the ICR field returns the <code>IcrNotAvailable</code> type when
                        the ICR is not available, the inline fragment on the{" "}
                        <code>IcrAvailable</code> type is ignored and effectively no fields
                        are queried, hence the result is empty.
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="record-check">Record Check</h3>
                    <p>
                        Record Check is a web page presented when an ICR is not available. A
                        consumer can purchase their own CARFAX Report from the Record Check
                        page. Record Check URLs do not expire.
                    </p>
                    <p>
                        If the ICR is not available, the <code>icr</code> field returns the
                        concrete type <code>IcrNotAvailable</code>, which contains the Record
                        Check URL. Both <code>IcrAvailable</code> and{" "}
                        <code>IcrNotAvailable</code> contain a <code>carfaxLink</code> field.
                        The concrete type of <code>carfaxLink</code> will be either{" "}
                        <code>IcrLink</code> or <code>RecordCheckLink</code> depending on
                        whether the ICR is available.
                    </p>
                    <p>
                        This query will return the ICR URL when available and the Record Check
                        URL otherwise:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query($icrInput: IcrInput!) {
    icr(icrInput: $icrInput) {
        __typename
        carfaxLink {
            url
            iconUrl
            ... on IcrLink {
                expiresAt {rfc}
            }
        }
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Only <code>IcrLink</code> has the <code>expiresAt</code> field, so an
                        inline fragment is used to query it only when the actual returned type
                        is <code>IcrLink</code>.
                    </p>
                    <p>
                        The <code>__typename</code> <a href="https://graphql.org/learn/queries/#meta-fields"
                                                       target="_blank"
                                                       rel="noopener noreferrer">
                        meta field
                    </a> is used to get a clear indication of whether the ICR was available.
                    </p>
                    <p>
                        Sample response when ICR is available:

                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            icr: {
                                                __typename: "IcrAvailable",
                                                carfaxLink: {
                                                    url:
                                                        "https://www.carfax.com/VehicleHistory/ar20/-wMiEB3EUtHUkt2RkuT",
                                                    iconUrl:
                                                        "https://partnerstatic.carfax.com/img/valuebadge/1own.svg",
                                                    expiresAt: {
                                                        rfc: "2020-02-07T20:57:48.233Z",
                                                    },
                                                },
                                            },
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample response when ICR is not available:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        data: {
                                            icr: {
                                                __typename: "IcrNotAvailable",
                                                carfaxLink: {
                                                    url:
                                                        "https://www.carfax.com/cfm/check_order.cfm?partner=XXX&vin=XXX",
                                                    iconUrl:
                                                        "https://partnerstatic.carfax.com/img/valuebadge/showme.svg",
                                                },
                                            },
                                        },
                                    }, null, 4
                                )
                            )
                        ]}/>
                    </p>
                </section>
                <hr/>

                <section>
                    <h3 id="consumer-snapshot">Consumer Snapshot</h3>
                    <p>
                        Snapshot is a simple html file generated for the client to give a 'snapshot' of key vehicle
                        history information.
                        When added to a dealer's website or consumer facing inventory website, Snapshot offers these
                        benefits:
                    </p>
                    <ul>
                        <li>
                            For all vehicles already featuring an Instant CARFAX Report, consumers may now see the same
                            data found in the header of the report.
                        </li>
                        <li>
                            With just a hover over the CARFAX logo, consumers can quickly see the key vehicle history
                            points for the given vehicle, allowing
                            them to make an informed buying decision.
                        </li>
                        <li>
                            Consumers may easily open the full CARFAX Report from Snapshot to access more vehicle
                            history details.{" "}
                        </li>
                    </ul>
                    <img src={imgConsumerSnapshot} alt="speSnapshot Example" className={"img-fluid"} width="250px"/>
                    <p>
                        Unlike the legacy Snapshot, the new Snapshot URL has a Snapshot key which hides the VIN
                        information.
                        Snapshot can be requested with the `icr` query as follows:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query ($icrInput: IcrInput!) {
  icr(icrInput: $icrInput) {
    ... on IcrAvailable {
      snapshotKey
    }
  }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Variables:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify({
                                    "icrInput": {
                                        "vin": "2FMDK4JCXDBE32641",
                                        "dealerId": "1504"
                                    }
                                }, null, 4)
                            )
                        ]}/>
                    </p>
                    <p>
                        Sample response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JSON,
                                "JSON",
                                JSON.stringify(
                                    {
                                        "data": {
                                            "icr": {
                                                "snapshotKey": "hOGrunhwZr9vJyRaN4OxVRN1W0wyIcj-ESllQV6p3-FUsmviY7UeI0fbFLSyxlEsnddSYpZ1hKBw8RytSB6odNBAwXB4Enz6wzw67g2h"
                                            }
                                        }
                                    },
                                    null,
                                    4
                                )
                            )
                        ]}/>
                        <p>
                            Information such as <code>vin</code> and <code>dealerCompCode</code> are embedded in the
                            snapshotKey; which can be used to render the Snapshot data
                            through the consumer Snapshot endpoint. The key is used to ensure that the requests being
                            made against our server are
                            authorized and can also be injected in an img or anchor tag to show the Snapshot html.
                        </p>
                    </p>
                    <h4 id="including-snapshotjs">Including Snapshot.js</h4>
                    <p>
                        When implementing Snapshot, you'll need to use our hosted JavaScript
                        file:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<script type="text/javascript" src="https://snapshot.carfax.com/latest/snapshot.js"></script>'
                            )
                        ]}/>
                    </p>
                    <p>
                        Generally, it should be included right before you close out your body
                        tag in your HTML document.
                    </p>
                    <h4 id="consumer-snapshot-hover-over">Consumer Snapshot Hover-Over</h4>
                    <p>
                        On a desktop application, we recognize that most existing promotions will show simply a CARFAX
                        logo or icon.
                        Hovering over the logo/icon will cause the Snapshot to render just to the side of the logo/icon.
                        {/*Clicking on the logo/icon should open the Instant CARFAX Report directly.{" "}*/}
                    </p>
                    <p>
                        Note that Snapshot is not supported as a hover-over on mobile devices. It is recommended to use
                        the embedded version of Snapshot on a VDP or to simply open the Instant CARFAX Report from an
                        SRP
                        link in mobile applications or websites.
                    </p>
                    <p>
                        Applying the bindings for the Snapshot hover-over is as easy as adding
                        only two attributes on your html element that you would like to display
                        Snapshot, when hovered over. The elements are as follows:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-snapshot-hover" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect icr query response.
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<img src="photo.jpg" class="carfax-snapshot-hover" data-snapshotkey="SnapshotKey"/>'
                            )
                        ]}/>
                    </p>
                    <h4 id="embedded-consumer-snapshot">Embedded Consumer Snapshot</h4>
                    <p>
                        The Consumer Snapshot may also be embedded on any vehicle detail page of a dealer's website or
                        consumer facing inventory website for
                        easy presentation of the CARFAX vehicle history. The embedded Snapshot displays just as the
                        hover-over version, however,
                        it’s not triggered by hovering over an element, and instead, it’s added to the page as it loads.
                        Just like the hover-over version of
                        Snapshot, the embedded version also allows consumers to click the Instant CARFAX Report link in
                        order to see the full report.
                    </p>
                    <p>
                        The class for the embedded Snapshot is “carfax-snapshot-embedded”. You
                        will want to include the same JavaScript library whether using the
                        embedded or pop-up version of Snapshot on a page. We also recommend
                        using a <code>{`<div>`}</code> element for the embedded Snapshot to
                        ensure everything is styled appropriately.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                'class="carfax-snapshot-embedded" data-snapshotkey="SnapshotKey"'
                            )
                        ]}/>
                    </p>
                    <p>
                        SnapshotKey = The key you will get back from the
                        Connect icr query response.
                    </p>
                    <p>
                        For example, an Image tag that shows the report when hovered over
                        would follow this pattern.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.MARKUP,
                                "HTML",
                                '<div class="carfax-snapshot-embedded" data-snapshotkey="SnapshotKey"></div>'
                            )
                        ]}/>
                    </p>
                    <h4 id={"refreshing snapshot"}>Refreshing Snapshot</h4>
                    <p>
                        To ensure that Snapshot displays the most up to date data and aligns with what the user sees on
                        the CARFAX Report we recommend
                        you reload the Snapshot.js file when the page reloads. In order to do so, please trigger the
                        'refreshSnapshotEvent' after the
                        Connect data has finished loading.
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.JAVASCRIPT,
                                "JavaScript",
                                `const refreshSnapshotEvent = new Event('refreshCarfaxSnapshotData');

document.dispatchEvent(refreshSnapshotEvent);`
                            )
                        ]}/>
                    </p>
                    <h4 id="specs">Specs</h4>
                    <p>
                        Snapshot is built to be resized responsively but we do have the
                        following min/max sizes that we suggest you use when rendering
                        Snapshot:
                    </p>
                    <ul>
                        <li>
                            Minimum width = 325 pixels
                        </li>
                        <li>
                            Maximum width = 450 pixels (a user may enlarge it beyond this but
                            the rows will simply stretch)
                        </li>
                        <li>
                            Maximum height = 434 pixels if the Year/Make/Model shows on one line or 455 pixels if the
                            Year/Make/Model shows on two lines
                        </li>
                    </ul>
                    <p>
                        Please note that the final implementation of Snapshot in your
                        application shall be mutually agreed to and approved by your CARFAX
                        account manager prior to launch. We encourage you to share screen
                        shots and/or provide beta access to your site to facilitate
                        this process.
                    </p>
                    <h4 id="sorry-message">Sorry Message</h4>
                    <p>
                        Should the report be unavailable, the service be down or the request
                        not properly authenticated, the consumer will receive a “sorry” message
                        like the one below that allows for the CARFAX Report to be purchased.
                        <br/>
                        <img src={imgSorryConsumerSnapshot} alt="Sorry Page" width="200" height="230"/>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"vehicle-information"}>Vehicle Information</h3>
                    <p>
                        In GraphQL, the data for the queries is returned in the same order that it was requested.
                        Although there may be Use Cases where the final state of the data is not in the same order.
                        In that case, there will need to be some sort of explicit mapping for the requested data with
                        its response.
                        CARFAX Connect supports the <code>Vehicle</code> Type which, combined with <code>dealerId</code>,
                        to map the requested data to its response:
                        <CodeSnippetTemplate codeSnippets={[
                            new CodeSnippet(
                                CodeSnippetLanguages.GRAPHQL,
                                "GraphQL",
                                `query($icrInput: IcrInput!) {
    icr(icrInput: $icrInput) {
        ... on IcrAvailable {
            carfaxLink {
                url
            }
            
            vehicle {
                vin
            }
            
            dealerId
        }   
    }
}`
                            )
                        ]}/>
                    </p>
                    <p>
                        Alternatively, <Link to={`${Constants.SEND_QUERIES_PAGE_URL}#graphql-aliases`}>GraphQL
                        Aliases</Link> can
                        be used to achieve this mapping.
                    </p>
                    <p>
                        Please note that the VIN is also returned in cases when an error occurs to aid in diagnosing the
                        given issue.
                        See <Link to={`${Constants.ERROR_HANDLING_PAGE_URL}`}>Error Handling</Link> for more information
                        and
                        examples of how the VIN is returned with errors.
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id="for-sale-by-owner">For Sale by Owner</h3>
                    <br/>
                    <h5>Overview</h5>
                    <p>
                        As a partner who provides the ability for consumers to list vehicles for sale on your site,
                        the For Sale By Owner (FSBO) product can be used to include a link to the CARFAX Report adding
                        value to your listings and facilitating quicker sales. Through CARFAX Connect a simple request
                        can be made that runs the report and returns a secure link, badge, and other possible features
                        such as Snapshot as provisioned to post.
                    </p>
                    <p>
                        While the CARFAX Report has a lifespan of 150 days the <strong>URLs expire after seven days for
                        security purposes.</strong> It is recommended that all FSBO VINs on your site be refreshed
                        nightly to ensure the badges are updated. If you are caching any data/links, be sure to refresh
                        it before the <code>expiresAt</code> timestamp.
                    </p>
                    <p>
                        Note that all reports run through CARFAX Connect using the FSBO product will be billed to the
                        requesting partner each month. Your Account Manager will work with you to set up invoicing.
                    </p>
                    <h5>ADA Compliance / Accessibility</h5>
                    <p>
                        CARFAX is committed to making our products accessible to everyone including people with
                        disabilities. We are continuously improving our sites and products to follow the Web Content
                        Accessibility Guidelines (WCAG). We recommend that our partners abide by the guidelines put
                        forward through WCAG. In doing so, we ask that all logos displayed on your sites and products
                        are properly coded to meet the standards of WCAG. The <code>valueBadgeAltText</code> value in
                        the Connect response provides the alternate text for all logos that can be displayed. Text
                        should be coded as ALT="Show Me the CARFAX 1-Owner Badge" for example.
                    </p>
                    <p>
                        Use the <code>forSaleByOwner</code> field to obtain the <code>forSaleByOwnerLink</code> elements
                        which returns the link to the report, image URL, alt text for the badge and expiration date for
                        the URL. To display the link on a web page, use the image provided in
                        the <code>iconUrl</code> field.
                        The image URL returned may either reflect a 1-Owner badge or a "Show Me" badge. The image is an
                        SVG, so you can easily scale it to fit your layout. The example mutation uses the RFC 3339/ISO
                        8601 human readable representation of the <code>expiresAt</code> timestamp.
                        The <code>Timestamp</code> type also offers an option for UNIX time as seconds or milliseconds,
                        which is easier to parse in many programming languages. Other products such as Snapshot and 4
                        Pillars may be returned if provisioned by your account manager.
                    </p>
                    Variables for the example mutation:
                    <br/>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.JSON,
                            "JSON",
                            JSON.stringify({
                                "vin": "2HKRM3H50DH520429"
                            }, null, 4)
                        )
                    ]}/>
                    <br/>
                    An example mutation that obtains the <code>forSaleByOwnerLink</code> is below:
                    <br/>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `mutation ($vin: Vin!){
    forSaleByOwner(vin: $vin){
        forSaleByOwnerLink{
            url
            iconUrl
            valueBadgeAltText
            expiresAt{
                unix
                unixMillis
                rfc
            }
        }
        accident {
            iconUrl
            iconText
            position
            hasAccidents
        }
        ownerHistory { 
            iconUrl
            iconText
            position
            oneOwner
            ownerDataAvailable
        }
        useType {
            iconUrl
            iconText
            position
            isPersonalUse
        }
        serviceRecord {
            iconUrl
            iconText
            position
            recordCount      
        }
        snapshotKey
    }
}`
                        )
                    ]}/>
                    <br/>
                    Sample result:
                    <br/>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.JSON,
                            "JSON",
                            `{
    "data": {
        "forSaleByOwner": {
            "forSaleByOwnerLink": {
                "url": "https://carfax.com/VehicleHistory/ar20/vxXiCctWb9qv-NzTXmqnYxoDPMimTWBX43-La_lYWyJYK4k-aPiGsAMKSgXmzhvECQzzOrWJ_vYygHJP_25lgb7iUkh5nmCenXsaEXNX",
                "iconUrl": "https://partnerstatic.carfax.com/img/valuebadge/1own.svg",
                "valueBadgeAltText": "Show Me the CARFAX 1-Owner Badge",
                "expiresAt": {
                    "unix": 1680032277,
                    "unixMillis": 1680032277321,
                    "rfc": "2023-03-28T19:37:57.321Z"
                }
            },
            "accident": {
                "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_noAccident.svg",
                "iconText": "No Accident or Damage Reported",
                "position": 1,
                "hasAccidents": false
            },
            "ownerHistory": {
                "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_owner1.svg",
                "iconText": "CARFAX 1-Owner",
                "position": 2,
                "oneOwner": true,
                "ownerDataAvailable": true
            },
            "useType": {
                "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_personal.svg",
                "iconText": "Personal Use",
                "position": 3,
                "isPersonalUse": true
            },
            "serviceRecord": {
                "iconUrl": "https://partnerstatic.carfax.com/img/vhr/ico_service.svg",
                "iconText": "Service History",
                "position": 4,
                "recordCount": 22
            },
            "snapshotKey": "vxXiCctWb9qv-NzTXmqnYxoDPMimTWBX43-La_lYWyJYK4k-aPiGsAMKSgXmzhvECQzzOrWJ_vYygHJP_25lgb7iUkh5nmCenXsaEXNX"
        }
    }
}`
                        )
                    ]}/>
                    <br/>
                    For further directions on how to request Snapshot, 4 Pillars and Vehicle Information via Connect if
                    provisioned by your account manager see the corresponding sections above on this page.
                    <br/>
                </section>

                <hr/>
                <section>
                    <h1 id={"car-care-header"}>Car Care Check</h1>
                    <p>
                        <strong>*Please note that Car Care Check is not assigned by default to a Consumer Partner. Your
                            CARFAX Account Manager will work with you to determine if this is a suitable product for
                            your specific use case.</strong>
                    </p>

                    <h3 id={"car-care-overview"}>Overview</h3>
                    <p>
                        CARFAX Car Care Check is a product delivered via CARFAX Connect that allows consumers using a
                        partner app or website to see if their vehicle has any open recalls, overdue services or
                        upcoming services due. The presentation of this valuable data drives consumer engagement in
                        your application or site while encouraging consumers to set up CARFAX Car Care accounts. A VIN
                        or License Plate/State along with the email address of the consumer when available is submitted
                        via a query to
                        fetch the three data points for display. A login URL is also returned and used to allow
                        consumers to navigate to
                        Car Care via the "View Service Details" button. Finally, to provide transparency regarding
                        safety recalls
                        consumers may easily view details via a hover-over from the info icon in the recall section.
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareCheck}
                            width="325px"
                            alt="Carfax Car Care"
                        />
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"car-care-prerequisites"}>Prerequisites</h3>
                    <p>
                        Before you can authenticate and start running queries on CARFAX Connect, you must be configured
                        by Carfax for the Car Care Check service and have a <strong>Client Credentials </strong>
                        Application set up in the Partner Portal. You can choose to use the one we provided
                        (App Type - Client Credentials) or use one that you create.
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={PartnerPortalApplications}
                            width="647px"
                            alt="Partner Portal: Applications Screen"
                        />
                    </p>
                    <hr/>
                    <h3 id={"car-care-authentication"}>Authentication</h3>
                    <p>
                        To get started, a lead developer will receive an invitation to the Connect Partner Portal as
                        noted on the <Link to={`${Constants.AUTHENTICATION_PAGE_URL}`}>Authentication</Link> page.
                    </p>
                    <p>
                        Once you have access to the Partner Portal, create a Client Credentials application. With the
                        Client Credentials application built, you next need to authenticate to receive an access token
                        (JWT). This token will allow you to make requests to CARFAX Connect in the form of GraphQL
                        queries to receive Car Care Check information for a given vehicle.
                    </p>
                    <p>
                        <strong>IMPORTANT:</strong> An access token once obtained is valid for 24 hours and should be
                        reused until it expires. Please do not fetch a new access token with each request. If coded
                        properly we would expect to see one refresh per day if calling from a single machine or perhaps
                        as many as 10 if using distributed machines to call Connect. The expiration is identified via
                        expires_in which is in seconds. Be sure to obtain a fresh token sufficiently far in advance to
                        allow for network delays and clock skew.
                    </p>
                    <p>
                        Refer to this documentation page for more information on how to establish the Client Credentials
                        application and authenticate - <Link to={`${Constants.CLIENT_AUTHENTICATION_PAGE_URL}`}>Client
                        Credentials Authentication</Link>
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"car-care-request"}>Sending a Request</h3>
                    <p>
                        Once you have successfully authenticated and have an access token (JWT), you may make a request
                        to receive Car Care Check information for a given VIN or a License Plate/State. Note that either
                        a VIN or License Plate/State may be used in the request but not both. Based on your use case you
                        may be provisioned with the ability to make requests with a VIN and/or License Plate/State. The
                        email field should
                        reflect the email address of the consumer submitting the request. This field is not required
                        but is recommended to use as the Car Care Check results will be more accurate if the email is
                        associated with a current CARFAX Car Care user. The email address also facilitates enrollment
                        in Car Care for those without an account. Examples are below showing a VIN and License
                        Plate/State query.
                    </p>
                    <p>
                        The following is the GraphQL Schema that you may use to make the request to CARFAX Connect for
                        a VIN:
                    </p>
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
    carCareCheck(
        vin: "1HGCG2254XA016592"
        email: "testemail1@carfax.com"
    ){
        integrationUrl
        licensePlate
        year
        make
        model
        state
        vin
        recalls
        recallDetails{
            date
            title
            nhtsa
            recallNumber
            recallStatus
            description
            remedy
        }
        services {
            due
            overdue
        }
    }
}`
                        )]}/>
                    <br/>
                    The following is the sample response to the above query in JSON:
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.JSON,
                            "JSON",
                            `{
    "data": {
        "carCareCheck": {
            "integrationUrl": "http://www.carfax.com/Service/login/partner/testpartner",
            "licensePlate": null,
            "year": "1999",
            "make": "Honda",
            "model": "ACCORD EX"
            "state": null,
            "vin": "1HGCG2254XA016592",
            "recalls": 1,
            "recallDetails": [
                {
                    "date": "2020-09-15",
                    "title": "Manufacturer Safety-related recall issued",
                    "nhtsa": "#20V-026",
                    "recallNumber": "#D8J Honda Multi-Model NADI Airbag Inflator Safety Recall",
                    "recallStatus": "Remedy Available",
                    "description": "American Honda Motor Co., Inc. (Honda) is recalling certain model year 1998-2000 Accord Coupe and Accord Sedan, 1996-2000 Civic Coupe, 1998-2000 Civic Sedan, 1997-2000 CR-V, 1997-1998 EV Plus, 1998-2000 Odyssey, and 1998-1999 Isuzu Oasis vehicles. These vehicles were equipped with Non-Azide Driver Airbag Inflators (NADI) and do not contain phase stabilized ammonium nitrate (PSAN) propellant. Due to a manufacturing issue, the NADI inflators may absorb moisture, causing the inflators to rupture or the airbag cushion to underinflate. In the event of a crash necessitating airbag deployment, an inflator rupture may result in metal fragments striking the driver or other occupants. An underinflated airbag cushion may not properly protect the occupant. These scenarios increase the risk of serious injury or death.",
                    "remedy": "Please call any authorized Honda dealer and make an appointment to have the driver frontal airbag inflator inspected and, if necessary, replaced with an inflator of a different design for free. For additional questions or to get help locating a dealer, owners may contact American Honda's Customer Support & Campaign Center at 1-888-234-2138."
                }
            ],
            "services": {
                "due": 0,
                "overdue": 1
            }
        }
    }
}`
                        )]}/>
                    <br/>
                    <br/>
                    The following is the GraphQL Schema that you may use to make the request to CARFAX Connect using a
                    License Plate/State:
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.GRAPHQL,
                            "GraphQL",
                            `query {
    carCareCheck(
        licensePlate: "6XG328"
        state: "WV"
        email: "testemail1@carfax.com"
    ){
        integrationUrl
        licensePlate
        year
        make
        model
        state
        vin
        recalls
        recallDetails{
            date
            title
            nhtsa
            recallNumber
            recallStatus
            description
            remedy
        }
        services {
            due
            overdue
        }
    }
}`
                        )]}/>
                    <br/>
                    The following is the sample response to the above query in JSON:
                    <CodeSnippetTemplate codeSnippets={[
                        new CodeSnippet(
                            CodeSnippetLanguages.JSON,
                            "JSON",
                            `{
    "data": {
        "carCareCheck": {
            "integrationUrl": "http://www.carfax.com/Service/login/partner/testpartner",
            "licensePlate": 6XG328,
            "year": "1999",
            "make": "Honda",
            "model": "ACCORD EX"
            "state": WV,
            "vin": "null",
            "recalls": 0,
            "recallDetails": [],
            "services": {
                "due": 0,
                "overdue": 1
            }
        }
    }
}`
                        )]}/>
                </section>
                <hr/>
                <section>
                    <h3 id={"car-care-errors"}>Errors</h3>
                    <p>
                        Error handling for Car Care Check is unique as most errors that impact the display of the three
                        data points can be disregarded and instead the copy and link to Carfax Car Care can remain on
                        screen such as below. In this case please link the "Take me to Car Care" button to the
                        integrationUrl
                        in the Connect response provided on non-error requests as it remains the same. See <Link
                        to={`${Constants.ERROR_HANDLING_PAGE_URL}`}>Error Handling</Link> for
                        more error cases and the Style Guide below for specifics and assets for this display.
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareError}
                            width="330"
                            alt="Carfax Care Car Error"
                        />
                    </p>
                    <p>
                        Below are error scenarios that are specific to Car Care Check and the corresponding response
                        provided by Connect which may be displayed to users in your application when the static display
                        above is not appropriate.
                    </p>
                    <table className="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th>Scenario</th>
                            <th>Error Code</th>
                            <th>Error Description</th>
                            <th>Displayable Error Message</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Invalid VIN</td>
                            <td>INVALID_VIN</td>
                            <td>VIN is malformed.</td>
                            <td>The VIN is not valid. Please enter a valid VIN post 1981 year 17 digit VIN.</td>
                        </tr>
                        <tr>
                            <td>Invalid Plate/State</td>
                            <td>INVALID_PLATE_STATE</td>
                            <td>Plate and/or state is malformed.</td>
                            <td>Plate and/or state is not valid. Please confirm and try again.</td>
                        </tr>
                        <tr>
                            <td>No Matching VIN</td>
                            <td>NO_MATCHING_VIN</td>
                            <td>Supplied plate/state is not associated with a VIN.</td>
                            <td>Plate and/or state is not associated with a VIN. Please confirm and try again or submit
                                a VIN.
                            </td>
                        </tr>
                        <tr>
                            <td>Multiple VINs for a plate/state</td>
                            <td>MULTIPLE_VINS</td>
                            <td>The supplied plate/state is linked to multiple VINs.</td>
                            <td>Multiple VINs associated with the supplied plate/state.</td>
                        </tr>
                        </tbody>
                    </table>
                    <p>
                        An example of how the Displayable Error Message may render on screen is below:
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareDisplayableErrorMessage}
                            width={380}
                            alt="Carfax Care Car Displayable Error Message"
                        />
                    </p>
                </section>
                <hr/>
                <section>
                    <h3 id={"car-care-style-guide"}>Style Guide/User Flow</h3>
                    <p>
                        CARFAX must approve the display of all integration. Please integrate CARFAX Car Care Check using
                        the assets and designs listed here for your respective application. SVG images for the icons,
                        logo
                        and Car Fox are posted below for download.
                    </p>
                    <p>
                        <h5>Case #1 - Site/App already has VIN or License Plate</h5>
                        If your site or application has the VIN or license plate already stored and can be used in the
                        Connect query please use the design below. Query Connect upon page load where Car Care Check is
                        integrated.
                        The following items are returned for use in the display:
                        <ol>
                            <li>Year/Make/Model of the vehicle</li>
                            <li>Car Care Check results</li>
                            <li>URL to link to the "View Service Details" button</li>
                        </ol>
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareStyleImageOne}
                            width="380"
                            alt="Carfax Care Car Style Image One"
                        />
                    </p>
                    <p>
                        Alternatively, if you feel your site/app requires a user to initiate the process this two step
                        design may be used where clicking "Check My Car" calls Connect:
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareCheckMyCar}
                            alt="Carfax Care Check My Car"
                        />
                    </p>
                    <p>
                        Note that in either case the titles in the three respective boxes should be singular or plural
                        based on the response from Connect.
                        For example, if "recalls": 2 is returned from Connect please post "2 Open Recall Alerts" but if
                        "recalls": 1 is returned post "1 Open Recall Alert".
                    </p>
                    <p>
                        <h5>Case #2 - Site/App requires a user to enter a VIN or License Plate</h5>
                        If your site or application requires the user to enter the VIN or license plate please use the
                        design below. Items of note:
                        <ul>
                            <li>
                                The default flow should feature the "License Plate" option where a user may input a
                                license plate and select from a U.S. state dropdown list.
                            </li>
                            <li>
                                The license plate field should allow for no more than ten characters.
                            </li>
                            <li>
                                Clicking "Get Started" calls Connect.
                            </li>
                            <li>
                                Same data points are returned as in Case #1 above.
                            </li>
                            <li>
                                "Check Another Vehicle" refreshes the module or screen and allows the user to input a
                                new plate/state or VIN.
                            </li>
                        </ul>
                        <p className={"img-fluid"}>
                            <img
                                src={CarCareLicensePlateData}
                                alt="Carfax Care License Plate Data"
                            />
                        </p>
                        <p>
                            The VIN entry alternative design when "VIN" is selected is below. The VIN field should allow
                            for
                            only 17 alphanumeric characters. Same flow as above follows the click of the "Get Started"
                            button.
                        </p>
                        <p className={"img-fluid"}>
                            <img
                                src={CarCareVinData}
                                width={380}
                                alt="Carfax Care Vin Data"
                            />
                        </p>
                        <p>
                            In a rare instance where there are no open recall alerts, services due or services overdue
                            please display
                            "0" for each but change the button to read "Take Me to Car Care".
                        </p>
                        <p className={"img-fluid"}>
                            <img
                                src={CarCareTakeMeToCarCare}
                                width={380}
                                alt="Carfax Care Take Me To Car Care"
                            />
                        </p>
                        <p>
                            Creative assets to use in building the Car Care Check module are listed below and may be
                            found in the downloadable Zip file.
                        </p>
                        <ul>
                            <li>CARFAX logo for placement next to "powered by" - CARFAX Logo.SVG
                            </li>
                            <li>Blue triangle for placement above "Open Recall Alerts" - Recall Alerts.SVG
                            </li>
                            <li>Blue info icon for placement in the Open Recall Alerts block to show recall details -
                                Info.SVG
                            </li>
                            <li>Blue bell for placement above "Service Due" - Services Due.SVG
                            </li>
                            <li>Blue exclamation point for placement above "Service Overdue" - Services Overdue.SVG</li>
                            <li>Car Fox - Car Fox.SVG
                            </li>
                        </ul>
                    </p>
                    <Button className={"images-download-button"} size={"medium"} theme={"blue"}
                            onClick={() => this.handleZip()}>Download
                    </Button>
                </section>
                <section>
                    <h5 id={"car-care-displaying-recall-details"}>Displaying Recall Details</h5>
                    <p>
                        To ensure consumers have easy access to critical recall details Car Care Check returns this
                        information for
                        display when one clicks or taps on the blue info icon in the Open Recall Alerts box. Below is an
                        example of
                        how the details should render in a modal. Clicking "Learn More" on any recall should open the
                        full Description and Remedy details.
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareRecallDetailsOne}
                            width={375}
                            alt="Carfax Care Recall Details Part One"
                        />
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareRecallDetailsTwo}
                            width={765}
                            alt="Carfax Care Recall Details Part Two"
                        />
                    </p>
                    <p>
                        Each of the fields in the design corresponds to the same data point under recallDetails in the
                        Connect response as noted below:
                    </p>
                    <p className={"img-fluid"}>
                        <img
                            src={CarCareRecallDetailsThree}
                            width={375}
                            alt="Carfax Care Recall Details Part Three"
                        />
                    </p>
                </section>
                <hr/>
                <ServiceLaneExperience/>
            </div>
        );
    }

    private handleZip = async () => {
        const zip = new JSZip()
        // Note: list the files we want zipped in backwards order
        const images = [CarCareCarFox, CarCareServiceOverdue, CarCareServiceDue, CarCareInfo, CarCareRecallAlert, CarCareCarfaxLogo]
        const imageName = ["Car Fox.svg", "Services Overdue.svg", "Services Due.svg", "Info.svg", "Recall Alerts.svg", "CARFAX Logo.svg"]

        let i = 0
        for (let image of images) {
            let response = await fetch(image)
            let blob = await response.blob()
            zip.file(imageName[i], image.replace(/.*\//g, ""))
            console.log(blob)
            zip.file(imageName[i], blob)
            i++
        }
        const zipData = await zip.generateAsync({
            type: "blob",
            streamFiles: true,
        });
        console.log(zipData);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(zipData);
        link.download = "car-care-check-images.zip";
        link.click();
    }
}
